import { ReduxService } from 'dashboard-services/services';

import { selectedUserMetadataActions } from 'actions/modules/myAccount';

export const selectedUserMetadataInitialState = {
  userMetadata: [],
  initialUserMetadata: [],
}

export default (state = selectedUserMetadataInitialState, action) => {
  switch (action.type) {
    case selectedUserMetadataActions.ADD_SELECTED_USER_METADATA_FIELD:
      return ReduxService.updateObject(state, { userMetadata: state.userMetadata.add(ReduxService.updateObject(selectedUserMetadataActions.EMPTY_USER_METADATA_FIELD, { metadataId: action.id })) })
    case selectedUserMetadataActions.CHANGE_SELECTED_USER_METADATA_FIELD:
      return ReduxService.updateObject(state, { userMetadata: state.userMetadata.updateInList({ [action.name]: action.value }, action.index) })
    case selectedUserMetadataActions.REMOVE_SELECTED_USER_METADATA_FIELD:
      return ReduxService.updateObject(state, { userMetadata: state.userMetadata.remove(action.index) })
    case selectedUserMetadataActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case selectedUserMetadataActions.CLEAN_ALL:
      return selectedUserMetadataInitialState;
    default:
      return state; 
  }
}